import {isServiceParticipant} from '../../../utils/aiBotUtils';

export const callPeople = (
    userIds: readonly string[],
    isService: (userId: string) => boolean = isServiceParticipant,
): string[] => [...new Set(userIds.filter(userId => !isService(userId)))];

export const countCallPeople = (
    userIds: readonly string[],
    isService: (userId: string) => boolean = isServiceParticipant,
): number => callPeople(userIds, isService).length;
